import { useContext, useState, useEffect, useRef } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useRetrieveCoupon() {
  const [fault, setFault] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestRetrieveCoupon = ({ newRequestData, headers }) => {
    const addedHeaders = [];
    const retentionData = ASCENDON_ENV_CONFIG.retentionConfiguration;

    const retrieveCouponUrl = `${retentionData?.retentionMicroserviceURL}/retrieve-coupon`;
    addedHeaders.push(
      { name: 'CD-SubscriberId', value: headers.subscriberId },
      { name: 'Content-Type', value: 'application/json' },
      { name: 'cache-control', value: 'no-cache' },
      {
        name: 'x-api-key',
        value: retentionData?.retentionMicroserviceApiKey,
      },
    );
    WebApi.subscriber({
      customUrl: retrieveCouponUrl,
      keyFactors: ['retention'],
      forceRefresh: true,
      payload: newRequestData,
      headers: {
        add: addedHeaders,
      },
    })
      .then((response) => {
        if (isMounted.current) {
          setUiModel(response?.data);
        }
      })
      .catch((error) => {
        if (isMounted.current) {
          const code = error?.data?.Code;
          let errorMsg;
          if (!code) {
            const unknownFault = generateUnhandledFault(error.data);
            errorMsg = translateFault(unknownFault).translatedMessage;
            setFault(errorMsg);
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
            setFault(errorMsg);
          }
        }
      });
  };
  return [uiModel, fault, requestRetrieveCoupon];
}

export { useRetrieveCoupon };
export default useRetrieveCoupon;
